<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>

    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :style="{margin:'5px'}">
          <a-col :span="12">
            <h2>Notice Boards</h2>
          </a-col>
          <a-col :span="12" :style="{textAlign:'end'}">
            <a-button type="primary" @click="addNewNoticeBoard">Add New Notice</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" :style="{background:'#fff'}">
            <div id="notices-table">
              <a-table
                  :columns="columns"
                  :loading="loading"
                  :rowKey="record => record.id"
                  :dataSource="notices"
                  :pagination="false"
              >
                <span slot="notice" slot-scope="actions,record">
                  <div v-html="record.notice"></div>
                </span>
                <span slot="status" slot-scope="actions, record">
                  <a-switch
                            v-cloak
                            checked-children="Active"
                            un-checked-children="Inactive"
                            :default-checked="record.status"
                            @change="statusToggle(record.id, record.status)"
                  />
                </span>
                <span slot="actions" slot-scope="actions,record">
                  <a-button
                      icon="eye"
                      type="primary"
                      :loading="loading"
                      @click="getNotice(record)"
                      style="margin-right: 10px"
                  ></a-button>
                  <a-button
                      icon="edit"
                      type="primary"
                      :loading="loading"
                      @click="editNotice(record)"
                      style="margin-right: 10px"
                  ></a-button>
                  <a-popconfirm
                    title="Are you sure delete this notice?"
                    placement="top"
                    @confirm="confirmDelete(record.id)"
                    okText="Yes"
                    cancelText="No"
                  >
                    <a-button
                      icon="delete"
                      type="danger"
                      :loading="record.id === deletingId ? true : false"
                    ></a-button>
                  </a-popconfirm>
                </span>
              </a-table>
            </div>
            <!-- New promotions modal -->
            <a-modal :title="noticeEditing ? 'Edit Notice' : 'Add New Notice'" :maskClosable="false" :footer="null" v-model="showNoticeForm" dialogClass="custom-modal-size">
              <a-form :form="form" @submit.prevent="noticeEditing ? updateNotice(form.id) : saveNewNoticeBoard()">
                <a-form-item label="Notice Title">
                  <a-col><a-input required v-model="form.title" /></a-col>
                </a-form-item>

                <a-form-item
                  label="Notice"
                  extra="This notice will be appeared on users dashboard"
                >
                  <a-col>
                    <VueEditor v-model="form.notice" :editorToolbar="customToolbar" id="editor"></VueEditor>
                  </a-col>
                </a-form-item>

                <a-form-item label="Button Lable (Optional)">
                  <a-col><a-input v-model="form.button_label" /></a-col>
                </a-form-item>

                <a-form-item label="Button Link (Optional)">
                  <a-col><a-input v-model="form.button_link" /></a-col>
                </a-form-item>

                <a-form-item label="Promo Code (Optional)">
                  <a-col><a-input v-model="form.promo_code" /></a-col>
                </a-form-item>

                <a-row :gutter="24">
                  <a-col span="14">
                    <a-form-item
                        label="Visible time range"
                        :extra="noticeEditing ? dateRange.starting_at + ' - ' + dateRange.ending_at : ''"
                    >
                      <a-range-picker
                          :disabled-date="disabledDate"
                          :show-time="{ format: 'HH:mm' }"
                          format="YYYY-MM-DD HH:mm"
                          :placeholder="['Start Time', 'End Time']"
                          @change="onChange"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col span="10">
                    <a-form-item label="Timezone">
                      <a-select v-model="timezone">
                        <a-select-option
                            v-for="timezone, index in timezones"
                            :key="index"
                            :value="timezone"
                        >
                          {{ timezone }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col span="8">
                    <a-form-item label="Type">
                      <a-select v-model="form.type">
                        <a-select-option value="warning">
                          Warning
                        </a-select-option>
                        <a-select-option value="success">
                          Success
                        </a-select-option>
                        <a-select-option value="others">
                          Others
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col span="8">
                    <a-form-item label="Target audience">
                      <a-select v-model="form.target_audience">
                        <a-select-option value="all_sites">
                          All Sites
                        </a-select-option>
                        <a-select-option value="free_sites">
                          Free Sites
                        </a-select-option>
                        <a-select-option value="paid_sites">
                          Premium Sites
                        </a-select-option>
                        <a-select-option value="vip_sites">
                          VIP Sites
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col span="8">
                    <a-form-item label="Status">
                      <a-select v-model="form.status" disabled>
                        <a-select-option value="1">
                          Active
                        </a-select-option>
                        <a-select-option value="0">
                          Inactive
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button size="large" type="default" @click.prevent="showNoticeForm = false;">Cancel</a-button>
                  <a-button style="margin-left: 10px;" type="primary" size="large" html-type="submit" :loading="submitting">{{ noticeEditing ? 'Update Notice' : 'Save Notice' }}</a-button>
                </a-form-item>
              </a-form>
            </a-modal>
            <a-modal title="Notice Details" :maskClosable="false" :footer="null" v-model="previewNotice" dialogClass="custom-modal-size">
              <div v-html="notice.notice"></div>
              <hr>
              <div>
                <p><strong>Notice Type:</strong>&nbsp;&nbsp;{{ notice.type }}</p>
                <p><strong>Target Audience:</strong>&nbsp;&nbsp;{{ notice.target_audience }}</p>
              </div>
            </a-modal>
          </a-col>
        </a-row>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
  import Sidebar from "@/components/Sidebar.vue";
  import Api from "@/services/Api";
  import moment from 'moment';
  import timezones from './../../services/timezones';
  import { VueEditor } from "vue2-editor";

  const columns = [
    {
      title: "Notice Title",
      dataIndex: "title",
      scopedSlots: { customRender: "title" }
    },
    {
      title: "Starting",
      dataIndex: "starting_at"
    },
    {
      title: "Ending",
      dataIndex: "ending_at"
    },
    {
      title: "Timezone",
      dataIndex: "timezone",
      scopedSlots: { customRender: "timezone" }
    },
    {
      title: "Status",
      dataIndex: "status",
      scopedSlots: { customRender: "status" }
    },
    {
      title: "Actions",
      dataIndex: "actions",
      scopedSlots: { customRender: "actions" }
    }
  ];

  export default {
    name: 'NoticeBoards',
    components: {
      Sidebar, VueEditor
    },
    data() {
      return {
        showNoticeForm: false,
        previewNotice: false,
        noticeEditing: false,
        form: {},
        columns,
        notices: [],
        loading: false,
        deletingId: null,
        submitting: false,
        timezones: [],
        timezone: 'EST',
        dateRange: {
          starting_at: null,
          ending_at: null,
        },
        notice: {},
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["code-block", "link"]]
      };
    },
    methods: {
      getNotice(notice) {
        this.notice = notice;
        this.previewNotice = true;
      },

      editNotice(notice) {
        this.fillFormData(notice);
        this.noticeEditing = true;
        this.showNoticeForm = true;
      },

      onChange(value, dateString) {
        this.dateRange.starting_at = dateString[0] + ':00';
        this.dateRange.ending_at = dateString[1] + ':00'
      },

      fillFormData(notice = false) {
        this.form = {
          id: notice ? notice.id : '',
          title: notice ? notice.title : '',
          notice: notice ? notice.notice : '',
          type: notice ? notice.type : 'success',
          starting_at: notice ? notice.starting_at : '',
          ending_at: notice ? notice.ending_at : '',
          target_audience: notice ? notice.target_audience : 'all_sites',
          status: notice ? (notice.status ? '1' : '0') : '1',
          button_label: notice ? notice.button_label : '',
          button_link: notice ? notice.button_link : '',
          promo_code: notice ? notice.promo_code : '',
        };

        if (notice) {
          this.dateRange = {
            starting_at: notice.starting_at,
            ending_at: notice.ending_at,
          }
        }
      },

      statusToggle(id, currentStatus) {
        this.loading = true;
        Api.put(`/notice-boards/${id}`, {
          status: !currentStatus
        }).then(resp => {
              this.loading = false;
              this.$notification['success']({
                message: 'Success',
                description: resp.data.data
              });
              this.loadNoticeBoards();
            }).catch(err => {
          this.loading = false;
          this.$notification['error']({
            message: 'Error',
            description: 'Something went wrong!'
          });
        });
      },

      addNewNoticeBoard() {
        this.fillFormData();
        this.timezone = 'EST';
        this.noticeEditing = false;
        this.showNoticeForm = true;
        this.submitting = false;
      },

      saveNewNoticeBoard() {
        const payload = this.generatePayload();
        this.submitting = true;
        Api.post('notice-boards', payload)
          .then((res) => {
            this.submitting = false;
            this.showNoticeForm = false;
            // Add default status
            const notice = res.data.notice;
            notice.status = true;
            this.notices.unshift(notice);

            this.$notification.success({
              message: 'Notice added.',
              description: res.data.message
            });
          })
          .catch(() => {
            this.submitting = false;
            this.$notification.error({
              message: 'Operation Failed!',
              description: "Something went wrong while submitting form. Check your inputs & retry again. Also, check response in network tab for more details."
            });
          });
      },

      updateNotice(id) {
        const payload = this.generatePayload();
        this.submitting = true;
        Api.put(`notice-boards/${id}`, payload)
          .then((res) => {
            this.submitting = false;
            this.showNoticeForm = false;
            this.$notification.success({
              message: 'Notice updated.',
              description: res.data.message
            });
            this.loadNoticeBoards();
          })
          .catch(() => {
            this.submitting = false;
            this.$notification.error({
              message: 'Operation Failed!',
              description: "Something went wrong while submitting form. Check your inputs & retry again. Also, check response in network tab for more details."
            });
          });
      },

      generatePayload() {
        const {
          id, title, notice, type, timezone, target_audience, status, button_label, button_link, promo_code
        } = this.form;
        const payload = { title, notice, type, timezone, target_audience, status, button_label, button_link, promo_code };
        if (id) payload.id = id;

        if (this.dateRange) {
          payload.starting_at = this.dateRange.starting_at;
          payload.ending_at = this.dateRange.ending_at;
          payload.timezone = this.timezone;
        }

        return payload;
      },

      confirmDelete(noticeId) {
        this.deletingId = noticeId;
        Api.delete(`notice-boards/${noticeId}`)
          .then(res => {
            this.notices = this.notices.filter(notice => notice.id !== noticeId);
            this.deletingId = null;
            this.$notification.success({
              message: res.data.message,
              description:
                'Notice has removed from successfully',
            });
            this.loadNoticeBoards();
          })
          .catch(err => {
            this.deletingId = null;
            this.$notification.error({
              message: 'Operation Failed!',
              description: err.response.data.message
            });
          })
      },

      disabledDate(current) {
        return current && current < moment().subtract(2, 'days').endOf('day');
      },

      loadNoticeBoards() {
        this.loading = true;
        Api.get('notice-boards')
        .then(res => {
          this.loading = false;
          this.notices = res.data.notices;
        })
        .catch(err => {
          this.loading = false;
          this.$notification.error({
            message: 'Server error.',
            description: err.response.data.message,
          });
        });
      }
    },

    created() {
      this.timezones = timezones.sort();
      this.loadNoticeBoards();
      this.fillFormData();
    }
  };
</script>

<style lang="scss">
  @media screen and (min-width: 767px) {
    @media screen and (min-width: 800px) {
      .custom-modal-size .ant-modal-content {
        width: 650px;
      }
    }

  }

   #editor {
     height: 100px;
   }
</style>